module.exports = {
          srcSet: __webpack_public_path__ + "a8f4a3eccad30a978e78a53b7b23c177-60.png"+" 60w",
          images:[ {path: __webpack_public_path__ + "a8f4a3eccad30a978e78a53b7b23c177-60.png",width: 60,height: 21}],
          src: __webpack_public_path__ + "a8f4a3eccad30a978e78a53b7b23c177-60.png",
          toString:function(){return __webpack_public_path__ + "a8f4a3eccad30a978e78a53b7b23c177-60.png"},
          
          width: 60,
          height: 21
        }